import { ReactElement } from 'react';
import { Box } from '@mui/material';
import { DataPointWithValue } from '@src/types/DataPoint';
import ValueLoader from '@components/_shared/ValueLoader';
import {
  deviceDataPointsSectionStyles,
  getValueContainerStyles,
} from './DeviceDataPointsSection.styles';

type DeviceDataPointsSectionProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  deviceDataPoints: DataPointWithValue[] | undefined;
  label: string;
};

function DeviceDataPointsSection(
  props: DeviceDataPointsSectionProps,
): ReactElement {
  const {
    translateXCoordinate,
    translateYCoordinate,
    deviceDataPoints,
    label,
  } = props;

  const { svgText, rowContainer, labelText, rect, foreignObject, layout } =
    deviceDataPointsSectionStyles;

  return (
    <g>
      <text
        x={translateXCoordinate}
        y={translateYCoordinate + layout.labelYOffset}
        {...svgText}
      >
        <tspan x={translateXCoordinate} dy={0}>
          {label}
          <br />
        </tspan>
      </text>

      <rect
        x={translateXCoordinate - layout.rectPadding}
        y={translateYCoordinate - layout.rowSpacing}
        width={layout.rectWidth}
        height={
          (deviceDataPoints?.length || 0) * layout.rowSpacing +
          layout.rectBottomPadding
        }
        {...rect}
      />

      {deviceDataPoints?.map((dataPoint: DataPointWithValue, index: number) => {
        const rowY = translateYCoordinate + index * layout.rowSpacing;

        return (
          <foreignObject
            key={`row-${index}`}
            x={translateXCoordinate - layout.rectPadding}
            y={rowY + foreignObject.yOffset}
            width={layout.rectWidth}
            height={foreignObject.rowHeight}
          >
            <Box sx={rowContainer}>
              <Box sx={labelText}>{`${dataPoint.displayName}:`}</Box>
              <Box sx={getValueContainerStyles(dataPoint.value === undefined)}>
                <ValueLoader dataPoint={dataPoint} />
              </Box>
            </Box>
          </foreignObject>
        );
      })}
    </g>
  );
}

export default DeviceDataPointsSection;
